import { FaArrowRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import classes from "./ServiceCardsGrid.module.css";

function renderHighlightedText(text, highlightText) {
  if (!text) return null;

  if (!highlightText) {
    return text;
  }

  const highlights = Array.isArray(highlightText)
    ? highlightText
    : [highlightText];

  const validHighlights = highlights.filter(
    (item) => typeof item === "string" && item.trim(),
  );

  if (!validHighlights.length) {
    return text;
  }

  const escapedHighlights = validHighlights.map((word) =>
    word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
  );

  const regex = new RegExp(`(${escapedHighlights.join("|")})`, "gi");

  return text.split(regex).map((part, index) => {
    const isHighlighted = validHighlights.some(
      (word) => part.toLowerCase() === word.toLowerCase(),
    );

    return isHighlighted ? (
      <span key={index} className={classes.highlight}>
        {part}
      </span>
    ) : (
      part
    );
  });
}

export default function ServiceCardsGrid({
  sectionTitle = "",
  sectionDescription = "",
  highlightText = [],
  cards = [],
}) {
  return (
    <section className={classes.section}>
      <div className={classes.shell}>
        <div className={classes.wrapper}>
          {(sectionTitle || sectionDescription) && (
            <header className={classes.header}>
              {sectionTitle && (
                <h2 className={classes.heading}>
                  {renderHighlightedText(sectionTitle, highlightText)}
                </h2>
              )}

              {sectionDescription && (
                <p className={classes.description}>
                  {sectionDescription}
                </p>
              )}
            </header>
          )}

          {cards.length > 0 && (
            <div className={classes.grid}>
              {cards.map((card, index) => {
                const Icon = card.icon;

                return (
                  <Link
                    key={card.id || card.title}
                    to={card.link || "#"}
                    className={classes.card}
                  >
                    <div className={classes.cardTop}>
                      {Icon && (
                        <span className={classes.cardIcon} aria-hidden="true">
                          <Icon />
                        </span>
                      )}
                    </div>

                    <div className={classes.cardBody}>
                      {card.title && (
                        <h3 className={classes.cardTitle}>{card.title}</h3>
                      )}

                      {card.description && (
                        <p className={classes.cardDescription}>
                          {card.description}
                        </p>
                      )}
                    </div>

                    {card.link && (
                      <span className={classes.cardFooter}>
                        <span>{card.linkText || "Explore Service"}</span>

                        <FaArrowRight
                          className={classes.arrowIcon}
                          aria-hidden="true"
                        />
                      </span>
                    )}
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
